import DefaultPrintOptions from "./DefaultPrintOptions";

export default DefaultPrintOptions;